export default {
  getCart: {
    uri: 'carts/%cart%',
    method: 'GET',
    loading: true,
    subdomain: true,
    needsVerified: false
  },
  addItemToCart: {
    uri: 'shops/%shop%/users/%user%/carts/%cartType%/items',
    method: 'POST',
    loading: true,
    subdomain: true,
    needsVerified: true
  },
  updateItemFromCart: {
    uri: 'shops/%shop%/users/%user%/carts/catalog/items/%item%',
    method: 'PUT',
    loading: true,
    subdomain: true,
    needsVerified: true
  },
  deleteItemFromCart: {
    uri: 'shops/%shop%/users/%user%/carts/catalog/items/%item%',
    method: 'DELETE',
    loading: true,
    subdomain: true,
    needsVerified: true
  },
  deleteActiveCart: {
    uri: 'shops/%shop%/users/%user%/carts/%cartType%',
    method: 'DELETE',
    loading: true,
    subdomain: true,
    needsVerified: true
  },
  setAddress: {
    uri: 'carts/%cart%/addresses/%address%',
    method: 'PUT',
    loading: true,
    subdomain: true,
    needsVerified: true
  },
  setPaymentDetail: {
    uri: 'carts/%cart%/payment_detail',
    method: 'PUT',
    loading: true,
    subdomain: true,
    needsVerified: true
  },
  setCarrier: {
    uri: 'carts/%cart%/carrier',
    method: 'PUT',
    loading: true,
    subdomain: true,
    needsVerified: true
  },
  cartToOrder: {
    uri: 'orders',
    method: 'POST',
    loading: true,
    subdomain: true,
    needsVerified: true
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/endpoints/cart.js